var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main home"},[_c('van-nav-bar',{attrs:{"title":_vm.newsContent.title,"left-arrow":"","placeholder":"","fixed":"","safe-area-inset-top":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}}),_c('van-cell-group'),_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.newsContent.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }